$("#finderProducts").keypress(function(e) {
    if(e.which == 13) {
        var word = $('#finderProducts').val();
        word = getCleanedString(word);
        searchProducts(word);
    }
});

$("#finderProductsMobile").keypress(function(e) {
    if(e.which == 13) {
        var word = $('#finderProductsMobile').val();
        word = getCleanedString(word);
        searchProducts(word);
    }
});


function searchProducts(word)
{
    if(word == ""){
        swal({
            text: "Debe digitar algo a buscar",
            icon: imageURL,
            button: "OK!",
        });
    }else{
        location.href = https + 'search/'+word;
    }
}

function getCleanedString(cadena){
    var specialChars = "!@#$^&%*()+=[]\/{}|:<>?,.";
    for (var i = 0; i < specialChars.length; i++) {
        cadena= cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
    }
    cadena = cadena.toLowerCase();
    cadena = cadena.replace(/ /g,"-");
    cadena = cadena.replace(/á/gi,"a");
    cadena = cadena.replace(/é/gi,"e");
    cadena = cadena.replace(/í/gi,"i");
    cadena = cadena.replace(/ó/gi,"o");
    cadena = cadena.replace(/ú/gi,"u");
    cadena = cadena.replace(/ñ/gi,"n");
    return cadena;
}
